import { Badge } from '@/components/ui/badge';
import type { Severity } from '@nirvik/shared';
import { cn } from '@/lib/utils';

const severityStyles: Record<Severity, string> = {
  critical: 'bg-red-100 dark:bg-red-900/40 text-red-800 dark:text-red-400 border-red-200 dark:border-red-500',
  high: 'bg-orange-100 dark:bg-orange-900/40 text-orange-800 dark:text-orange-400 border-orange-200 dark:border-orange-500',
  medium: 'bg-yellow-100 dark:bg-yellow-900/40 text-yellow-800 dark:text-yellow-400 border-yellow-200 dark:border-yellow-500',
  low: 'bg-blue-100 dark:bg-blue-900/40 text-blue-800 dark:text-blue-400 border-blue-200 dark:border-blue-500',
  info: 'bg-gray-100 dark:bg-muted text-muted-foreground dark:text-muted-foreground border-gray-200 dark:border-border',
};

const severityLabels: Record<Severity, string> = {
  critical: 'Critical',
  high: 'High',
  medium: 'Medium',
  low: 'Low',
  info: 'Info',
};

export function SeverityBadge({ severity, count }: { severity: Severity; count?: number }) {
  return (
    <Badge variant="outline" className={cn('font-medium', severityStyles[severity])}>
      {severityLabels[severity]}
      {count !== undefined && <span className="ml-1.5 font-bold">{count}</span>}
    </Badge>
  );
}
